import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	font-family: "Mulish";

	padding: 1rem;

	width: 100%;
	height: 100%;

	overflow: auto;

	background-color: #f5f5f5;

	.show {
		display: flex;
	}
	.hidden {
		display: none;
	}
	.pop-up {
		display: flex;
		flex-direction: column;

		align-items: center;

		padding: 2rem;
		gap: 2rem;

		border-radius: 0.25rem;

		width: 100%;
		height: 40%;

		background-color: white;

		label {
			display: flex;

			gap: 0.5rem;

			color: #2d7bbc;

			font-weight: bold;

			align-items: center;
		}

		button {
			width: 100%;
			padding: 1rem;

			border: 1px solid #2d7bbc;
			border-radius: 0.25rem;

			cursor: pointer;

			font-size: 1.5rem;
			font-weight: 600;

			text-transform: uppercase;

			color: #2d7bbc;
			background-color: white;
			:hover {
				color: white;
				background-color: #2d7bbc;
			}
		}
	}
	.link-button {
		width: 50%;
	}
	.pop-header {
		font-size: 2rem;
		color: #2d7bbc;
		font-weight: bold;
	}

	.pop-up-text {
		font-weight: bold;
		font-size: 1.2rem;

		text-transform: uppercase;

		color: black;
	}

	#aproved {
		color: #ea7745;
	}

	#reproved {
		color: #d11919;
	}
`;

export const Content = styled.div`
	display: flex;

	align-items: center;
	justify-content: center;
	gap: 2rem;

	width: 100%;
	height: 100%;

	.left-side {
		display: flex;
		flex-direction: column;

		gap: 2rem;

		height: 95%;
		width: 50%;
	}
	.quests-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;

		width: 100%;
		height: 60%;

		gap: 1rem;
		padding: 1rem;

		border-radius: 1rem;

		background-color: white;
		box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
	}
	.txt-header {
		text-transform: uppercase;
		font-weight: bold;
		font-size: 1.6rem;
		color: #2d7bbc;
	}
	.quests {
		width: 100%;
		height: 30rem;

		overflow: auto;
	}
	.final-status {
		width: 50%;
		height: 20%;
		label {
			display: flex;
			flex-direction: column;

			gap: 1rem;
			font-size: 1.3rem;

			font-weight: bold;
			color: #2d7bbc;
		}
	}

	.button-wrapper {
		display: flex;

		width: 100%;
		height: 10%;

		gap: 1rem;

		button {
			height: 3rem;

			padding: 1rem;
			border: none;

			border-radius: 0.25rem;

			cursor: pointer;

			text-transform: uppercase;

			font-size: 1.2rem;
			font-weight: 600;

			transition: 0.25s;
		}

		#submit {
			color: #2d7bbc;
			border: 1px solid #2d7bbc;
			background-color: white;
			:hover {
				background-color: #2d7bbc;
				color: white;
			}
		}

		#not-ready {
			border: 1px solid #cacaca;

			color: #cacaca;

			background-color: white;

			cursor: default;
		}

		#cancel-button {
			color: #2d7bbc;

			background-color: white;

			border: 1px solid #2d7bbc;

			:hover {
				color: red;

				border-color: red;
			}
		}
	}
`;
